import { fileToUrl } from '@modules/file-menagement/fileUtils';
import { useEffect } from 'react';
import { AIInputStateControl } from 'src/features/AIInput';
import { useAIAudioPlayerState } from './useAIAudioPlayerState';
import { useTextToSpeechMutation } from './useTextToSpeechMutation';

export const useAIAudioPlayer = (store: AIInputStateControl) => {
  const { setIsPlaying, addAudio, setIsLoading, audioPlayer } =
    useAIAudioPlayerState();
  const { textToSpeech } = useTextToSpeechMutation(store);

  useEffect(() => {
    audioPlayer.addEventListener('ended', () => {
      setIsPlaying('');
    });
    return () =>
      audioPlayer.removeEventListener('ended', () => {
        setIsPlaying('');
      });
  }, [setIsPlaying, audioPlayer]);

  const getAudioFromText = async (messageId: string, text: string) => {
    setIsLoading(messageId, true);
    const response = await textToSpeech({
      text,
      messageId,
    });
    const blob = response.audio;
    const file = new File([blob], 'audio.aac');
    const audio = fileToUrl(file);
    addAudio(messageId, audio);
    setIsLoading(messageId, false);
    return audio;
  };

  const play = (audio: string, messageId: string) => {
    stop();
    setIsPlaying(messageId);
    audioPlayer.src = audio;
    audioPlayer.play();
  };

  const stop = () => {
    audioPlayer.pause();
    setIsPlaying('');
  };

  return {
    getAudioFromText,
    play,
    stop,
  };
};
